import { StringAccessClaimRule, RestrictedStringAccessClaimRule } from "./StringAccessClaimRule.js";
const allPermissions = ["create", "read", "update", "delete"];
const policyType = "policy";
class Policy {
  module;
  submodule;
  permission;
  constructor(...args) {
    const policyParts = args?.length === 1 && args[0]?.includes(":") ? args[0].split(":") : args;
    this.module = policyParts[0];
    if (allPermissions.find((permission) => permission === policyParts[1])) {
      this.permission = policyParts[1];
    } else {
      this.submodule = policyParts[1];
      this.permission = policyParts[2];
    }
  }
  get type() {
    return policyType;
  }
  toString() {
    let policy = this.module;
    if (this.submodule) {
      policy = `${policy}:${this.submodule}`;
    }
    if (this.permission) {
      policy = `${policy}:${this.permission}`;
    }
    return policy;
  }
  parse() {
    return { module: this.module, submodule: this.submodule, permission: this.permission };
  }
}
class PoliciesAccessRule extends StringAccessClaimRule {
  constructor(policies) {
    super(policies, policyType);
  }
  getToStringPrefix() {
    return "Policies include";
  }
}
class RestrictedPoliciesAccessRule extends RestrictedStringAccessClaimRule {
  constructor(policies) {
    super(policies, policyType);
  }
  getToStringPrefix() {
    return "Policies do not include";
  }
}
export {
  PoliciesAccessRule,
  Policy,
  RestrictedPoliciesAccessRule
};
//# sourceMappingURL=PoliciesAccessRule.js.map
